import {types} from './types';

const initialState = {
    view: null,
    list_replenishment: {
        replenishment: []
    },
    list_withdrawal: {
        withdrawal: []
    }
}

export function ggrReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GGR:
            return { ...state, view: action.payload};
        case types.SET_OPERATION_REPLENISHMENT:
            return { ...state, list_replenishment: action.payload};
        case types.SET_OPERATION_WITHDRAWAL:
            return { ...state, list_withdrawal: action.payload};
        default:
            return state
    }
}